import * as echarts_3 from 'echarts';
import $math from './math.js'
export default class Echarts {

    constructor(arg) {
        this.echartsTarget = null;
        // this.$dealData = arg.$dealData;
        this.callback = arg.callback;
        this.echartType = arg.echartType;
        this.echartsId = arg.echartsId;
        this.options = arg.echartOptions;
        this.echartOptions = arg.echartOptions;
        this.dealDataCallBack = arg.dealDataCallBack;
        this.legendCallback = arg.legendCallback;
        this.renderData = arg.renderData;
        this.isInitChart = arg.isInitChart;
        this.init()
    }

    init() {
        let self = this;
        // && !echarts_3.getInstanceByDom(document.getElementById(this.echartsId))
        if (!document.getElementById(this.echartsId)) {
            // self.dispose();
            setTimeout(() => {
                self.init()
            }, 50)
        } else {
            if (!self.echartsTarget) {
                self.echartsTarget = echarts_3.init(document.getElementById(self.echartsId));
            }
            if(this.isInitChart){
                this.drawChart()
            }

            // 屏幕相应重绘
            window.addEventListener("resize", function () {
                self.resize()
            })
            // 绑定点击事件
            this.echartsTarget.on('click', function (params) {
                if (params.data.children && params.data.children.length > 0) {
                    // self.clear()
                    self.echartType = params.data.echartType;
                    self.drawChart(params.data.children)
                }
            })
            this.echartsTarget.on('legendselectchanged', function (params) {
                self.legendCallback(params, self.echartsTarget, self.options)
            })
        }
    }




    // 绘制图形
    drawChart(options = {}) {
        // 当未传入echartType或者传入的echartType和当前绘制的echartType一样时，不触发重新绘制
        // if (echartType) {
        //     this.clear()
        // }
        let self = this;
        // if ( this.echartType) {
        // this.echartType = echartType ? echartType : this.echartType;
        // if (echartType) {
        //     this.cacheClickData(this.renderData, 'del')
        // } else {
        //     this.cacheClickData(this.renderData);
        // }
        // 进行扩展参数的初始化
        // this.options = JSON.parse(JSON.stringify({
        //     ...this.getDefaultOptions(),
        //     ...this.echartOptions
        // }));
        // this.clear()
        this.options = {
            ...this.getDefaultOptions(),
            ...this.echartOptions,
            ...options
        };

        // 绘制前数据的进一步处理
        this.dealDataCallBack ? this.dealDataCallBack(this.renderData, this.options, $math) : ''

        // 清空画布
        // this.clear()

        // 进行数据重绘
        setTimeout(() => {
            try {
                self.echartsTarget.setOption(self.options, true, false);
            } catch (error) { }
        }, 50)
        // }

    }

    resize(cb) {
        let self = this;
        setTimeout(() => {
            if (self.echartsTarget) {
                self.echartsTarget.resize();
                cb ? cb() : ''
            }
        }, 500)
    }


    cacheClickData(data, type = 'push') {
        this.callback ? this.callback(type, this.echartType, this.echartsId, data) : ''
    }


    /**
     * 清空图表
     */
    clear() {
        if (this.echartsTarget) {
            this.echartsTarget.clear();
        }
    }

    /**
     * 销毁图表
     */
    dispose() {
        if (this.echartsTarget) {
            this.echartsTarget.dispose();
        }
    }

    /**
    * 获取默认配置
    * @param {*}  
    * @returns 
    */
    getDefaultOptions() {
        return {
            /**
             * 漏斗图
             */
            funnel: {
                title: {
                    // text: '漏斗图',
                    // subtext: '纯属虚构'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c}"
                },
                toolbox: {
                    feature: {
                        dataView: { readOnly: false },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                legend: {
                    data: ['展现', '点击', '访问', '咨询', '订单']
                },

                series: [
                    {
                        name: '漏斗图',
                        type: 'funnel',
                        left: '10%',
                        top: 60,
                        //x2: 80,
                        bottom: 60,
                        width: '80%',
                        // height: {totalHeight} - y - y2,
                        // minSize: '0%',
                        // maxSize: '100%',
                        sort: 'descending',
                        gap: 2,
                        label: {
                            show: true,
                            position: 'inside'
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        emphasis: {
                            label: {
                                fontSize: 20
                            }
                        },
                        data: [
                            { value: 60, name: '访问' },
                            { value: 40, name: '咨询' },
                            { value: 20, name: '订单' },
                            { value: 80, name: '点击' },
                            { value: 100, name: '展现' }
                        ]
                    }
                ]
            },
            line: {
                title: {
                    // text: '堆叠区域图'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter(val) {
                        return val;
                    }
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    show: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#F8F8F8"
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: "#364366",
                        fontFamily:
                            "Montserrat-Regular",
                        fontWeight: 400,
                        fontSize: 12,
                        formatter: "{value}"
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#F8F8F8"
                        }
                    }
                },
                yAxis: {
                    show: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#F8F8F8"
                        }
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "#F8F8F8"
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: "#364366",
                        fontFamily:
                            "Montserrat-Regular",
                        fontWeight: 400,
                        fontSize: 12,
                        formatter: "{value} k"
                    }
                },
                series: [
                    {
                        type: "line",
                        smooth: true,
                        data: [
                            ["10/10", 0],
                            ["10/11", 560],
                            ["10/12", 750],
                            ["10/13", 580],
                            ["10/14", 250],
                            ["10/15", 300],
                            ["10/16", 450],
                            ["10/17", 300],
                            ["10/18", 100]
                        ]
                    }
                ]
            },
            sankey: {
                title: {
                    subtext: '数据来自 GitHub ID: lisachristina1234',
                    left: 'center'
                },
                backgroundColor: '#FFFFFF',
                series: [
                    {
                        type: 'sankey',
                        left: 50.0,
                        top: 20.0,
                        right: 150.0,
                        bottom: 25.0,
                        data: [],
                        tooltip: {
                            trigger: 'item'
                        }
                    }
                ]
            },
            bar: {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c}"
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                legend: {
                    data: []
                },
                grid: {
                    height: 250
                },
                yAxis: {
                    type: 'value',
                    formatter: ''
                },
                series: [
                    {
                        data: [],
                        type: 'bar'
                    }
                ]
            },
            pie: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '40',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 1048, name: 'Search Engine' },
                            { value: 735, name: 'Direct' },
                            { value: 580, name: 'Email' },
                            { value: 484, name: 'Union Ads' },
                            { value: 300, name: 'Video Ads' }
                        ]
                    }
                ]
            },
            gauge: {
                series: [
                    {
                        type: 'gauge',
                        radius: '70',
                        center: ['50%', '70%'],
                        startAngle: 359.9,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        // 刻度盘颜色
                        itemStyle: {
                            borderWidth: 0,
                        },
                        progress: {
                            show: false,
                            roundCap: true,
                            width: 14,
                            itemStyle: {
                                // color:'green'
                            }
                        },
                        pointer: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        title: {
                            offsetCenter: [0, '20%'],
                            fontSize: 14,
                            color: '#979797',
                            lineHeight: 60
                        },
                        detail: {
                            show: false,
                        },
                        data: [
                            {
                                value: 40,
                                name: '23'
                            }
                        ]
                    }
                ]
            },
            gauge2: {
                series: [
                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        // 刻度盘颜色
                        itemStyle: {
                            borderWidth: 0,
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 14,
                        },
                        pointer: {
                            show: true,
                            roundCap: true,
                            icon: 'triangle',
                            length: '110%',
                            width: 3,
                            offsetCenter: [0, '5%']
                        },
                        axisLine: {
                            roundCap: false,
                            lineStyle: {
                                width: 14,
                                color: [[1, '#eee']]
                                // color: [1,['#eee']]
                                // shadowColor: 'rgba(0, 0, 0, 0.5)',
                                // shadowBlur: 10
                            }
                        },
                        // axisLine: {
                        //     show:true,
                        //     roundCap: true,
                        //     lineStyle: {
                        //         width: 14
                        //     }
                        // },
                        axisTick: {
                            show: false,
                            splitNumber: 2,
                            lineStyle: {
                                width: 2,
                                color: '#999'
                            }
                        },
                        splitLine: {
                            show: false,
                            distance: -32,
                            length: 30,
                            lineStyle: {
                                width: 3,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            show: true,
                            distance: -40,
                            color: '#999',
                            fontSize: 12,
                            formatter: function (value) {
                                if (value === 0 || value == 100) {
                                    return value == 100 ? `{b|${value}%}` : `{b|${value}%}`;
                                } else {
                                    return ''
                                }
                            },
                            rich: {
                                b: {
                                    fontSize: 12,
                                    color: '#000',
                                    padding: [40, 40, 0, 40],
                                },
                            }
                        },
                        title: {
                            offsetCenter: [0, '20%'],
                            fontSize: 14,
                            color: '#979797',
                            lineHeight: 60
                        },
                        detail: {
                            backgroundColor: 'transparent',
                            width: '60%',
                            lineHeight: 40,
                            height: 40,
                            borderRadius: 8,
                            offsetCenter: [0, '-20%'],
                            valueAnimation: true,
                            formatter: function (value) {
                                return '{value|' + value.toFixed(0) + '}{unit|%}';
                            },
                            rich: {
                                value: {
                                    fontSize: 22,
                                    fontWeight: 'bolder',
                                    color: '#333333'
                                },
                                unit: {
                                    fontSize: 22,
                                    color: '#333333',
                                }
                            }
                        },
                        data: [
                            {
                                value: 40,
                                name: '23'
                            }
                        ]
                    },

                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        pointer: {
                            showAbove: true,
                            roundCap: true,
                            show: true,
                            icon: 'diamond',
                            length: '15%',
                            width: 4,
                            offsetCenter: [0, '-65%'],
                            itemStyle: {
                                color: 'green'
                            }
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        title: {
                            show: false,
                        },
                        detail: {
                            show: false
                        },
                        data: [
                            {
                                value: 40
                            }
                        ]
                    },
                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        pointer: {
                            showAbove: true,
                            roundCap: true,
                            show: true,
                            icon: 'diamond',
                            length: '15%',
                            width: 4,
                            offsetCenter: [0, '-65%'],
                            itemStyle: {
                                color: 'blue'
                            }
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        title: {
                            show: false,
                        },
                        detail: {
                            show: false
                        },
                        data: [
                            {
                                value: 40
                            }
                        ]
                    },
                ]
            },
            gauge3: {
                series: [
                    {
                        type: 'gauge',
                        radius: '70',
                        center: ['50%', '70%'],
                        startAngle: 0,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        // 刻度盘颜色
                        itemStyle: {
                            borderWidth: 0,
                        },
                        progress: {
                            show: false,
                            roundCap: true,
                            width: 14,
                            itemStyle: {
                                // color:'green'
                            }
                        },
                        pointer: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        title: {
                            offsetCenter: [0, '20%'],
                            fontSize: 14,
                            color: '#979797',
                            lineHeight: 60
                        },
                        detail: {
                            show: false,
                        },
                        data: [
                            {
                                value: 40,
                                name: '23'
                            }
                        ]
                    },
                    {
                        type: 'gauge',
                        radius: '70',
                        center: ['50%', '70%'],
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        // 刻度盘颜色
                        itemStyle: {
                            borderWidth: 0,
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 14,
                            itemStyle: {
                                // color:'blue'
                            }
                        },
                        pointer: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        title: {
                            offsetCenter: [0, '20%'],
                            fontSize: 14,
                            color: '#979797',
                            lineHeight: 60
                        },
                        detail: {
                            show: false,
                        },
                        data: [
                            {
                                value: 40,
                                name: '23'
                            }
                        ]
                    },
                    {
                        type: 'gauge',
                        radius: '70',
                        center: ['50%', '70%'],
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        name: '23123',
                        splitNumber: 10,
                        // 刻度盘颜色
                        itemStyle: {
                            borderWidth: 0,
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 14,
                            itemStyle: {
                                color: 'red'
                            }
                        },
                        pointer: {
                            show: false,
                        },
                        axisLine: {
                            roundCap: true,
                            lineStyle: {
                                width: 14,
                                color: [[1, '#eee']]
                                // color: [1,['#eee']]
                                // shadowColor: 'rgba(0, 0, 0, 0.5)',
                                // shadowBlur: 10
                            }
                        },
                        // axisLine: {
                        //     show:true,
                        //     roundCap: true,
                        //     lineStyle: {
                        //         width: 14
                        //     }
                        // },
                        axisTick: {
                            show: false,
                            splitNumber: 2,
                            lineStyle: {
                                width: 2,
                                color: '#999'
                            }
                        },
                        splitLine: {
                            show: false,
                            distance: -32,
                            length: 30,
                            lineStyle: {
                                width: 3,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            show: true,
                            distance: -40,
                            color: '#999',
                            fontSize: 12,
                            formatter: function (value) {
                                if (true) {
                                    return value == 100 ? `{b|${value}%}` : `{b|${value}%}`;
                                } else {
                                    return ''
                                }
                            },
                            rich: {
                                b: {
                                    fontSize: 12,
                                    color: '#000',
                                    padding: [40, 40, 0, 40],
                                },
                            }
                        },
                        title: {
                            offsetCenter: [0, '20%'],
                            fontSize: 14,
                            color: '#979797',
                            lineHeight: 60
                        },
                        detail: {
                            backgroundColor: 'transparent',
                            width: '60%',
                            lineHeight: 40,
                            height: 40,
                            borderRadius: 8,
                            offsetCenter: [0, '-20%'],
                            valueAnimation: true,
                            formatter: function (value) {
                                return '{value|' + value + '}{unit|%}';
                            },
                            rich: {
                                value: {
                                    fontSize: 22,
                                    fontWeight: 'bolder',
                                    color: '#333333'
                                },
                                unit: {
                                    fontSize: 22,
                                    color: '#333333',
                                }
                            }
                        },
                        data: [
                            {
                                value: 40,
                                name: '23'
                            }
                        ]
                    },

                ]
            }
        }[this.echartType]
    }

}


// WEBPACK FOOTER //
// ./src/util/toolClass/echarts.js